import { KeyRound } from "lucide-react";
import { useLocation } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { BrandButton } from "@/components/kit/BrandButton";
import { EmptyState } from "@/components/kit/EmptyState";
import { AppSkeleton, ProfileSkeleton } from "@/components/kit/Skeleton";
import { useAuth } from "@/lib/auth";

/** While we work out who the reader is, show the shape of the page they asked for. */
const Splash = () => {
  const { pathname } = useLocation();
  const profile = pathname.startsWith("/profile");
  return (
    <AppShell
      title={profile ? "Profile" : "Plattershare"}
      showBack={false}
      nav={profile}
      size="reading"
    >
      {profile ? <ProfileSkeleton /> : <AppSkeleton />}
    </AppShell>
  );
};

/** Auth gate. Never a login form — customers always return via Plattershare. */
export const RequireAuth = ({ children }) => {
  const { status } = useAuth();

  if (status === "loading") return <Splash />;

  if (status === "anonymous") {
    return (
      <AppShell title="Sign in required" showBack={false} nav={false} size="reading">
        <div data-testid="page-signed-out" className="contents">
          <EmptyState
            icon={KeyRound}
            title="Please reopen your program"
            description="For your security, access to your meal plan starts from your Plattershare account. Sign in there and choose My Programs to continue."
          >
            <BrandButton
              as="a"
              name="signin-plattershare"
              href="https://www.plattershare.com/sign-in/"
              rel="noopener"
            >
              Go to Plattershare
            </BrandButton>
          </EmptyState>
        </div>
      </AppShell>
    );
  }

  return children;
};
